import './CenteredPageContainer.scss';
import classNames from 'classnames';
import React, { FC } from 'react';
import dashworksLogo from '../../../assets/images/dashworks_logo_long.svg';
import swiggyLogo from '../../../assets/images/swiggy_logo_long.png';

export const CenteredPageContainer: FC<{ classes: string }> = ({
  classes,
  children,
}) => {
  return (
    <div className={classNames('centeredPageContainer', classes)}>
      {location.origin === 'https://searchit.swiggy.in' ? (
        <img className="customLogo" src={swiggyLogo} />
      ) : (
        <img className="dashworksLogo" src={dashworksLogo} />
      )}
      {children}
    </div>
  );
};
